module.exports = __webpack_public_path__ + "static/image/main/m/banner-5-1.ver2_0_2.jpg?d4a414f6";